<template>
  <div class="backgr" v-if="!isMobile">
    <img src="../assets/images/logo.svg" class="logo-desktop">
    <FormLogin v-if="!isMobile" />
  </div>
  <div class="backgr-mobile" v-else>
    <img src="../assets/images/logo.svg" class="logo-mobile">
    <transition name="robot-fade">
      <img v-if="robotShow" src="../assets/images/robot_mobile.svg" class="robot-image">
    </transition>
    <FormLoginMobile @removeRobot="robotShow = false" />
  </div>
</template>
<script>
import FormLogin from '@/components/auth/byUserName/FormLogin.vue'
import FormLoginMobile from '@/components/auth/byUserName/FormLoginMobile.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: {
    FormLogin,
    FormLoginMobile
  },
  data: () => ({
    isMobile: false,
    email: "",
    password: "",
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    robotShow: true,
  }),
  mounted() {
    document.title = 'כניסה | clickcallmobile'
    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "callHistory" })
    }
    if (window.innerWidth <= 1000) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    this.robotShow = true;
    next();
  },
}
</script>
<style scoped>
.backgr {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/images/login_back.svg');
  background-size: cover;
  background-repeat: no-repeat;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
  transform: translateZ(0);
  animation: pages_colorIn__r4Ogf 2.5s ease-out;
}

.backgr-mobile {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-image: url('../assets/images/login_back_mobile.svg');
  background-size: cover;
  background-repeat: no-repeat;
  align-items: center;
  padding: 15px;
  box-sizing: border-box;
  transform: translateZ(0);
  animation: pages_colorIn__r4Ogf 2.5s ease-out;
}

/* Added logo animations and hover effects */
.logo-desktop {
  width: 15%;
  position: absolute;
  left: 7%;
  top: 7%;
  animation: fadeInDown 1s ease-out;
  transition: transform 0.3s ease;
}

.logo-desktop:hover {
  transform: scale(1.05);
}

.logo-mobile {
  width: 30%;
  position: absolute;
  left: 7%;
  top: 7%;
  animation: fadeInDown 1s ease-out;
  z-index: 10;
}

/* Added floating animation for robot with shadow */
.robot-image {
  position: absolute;
  right: 0%;
  top: 2%;
  bottom: 60%;
  max-height: 50%;
  animation: floatingRobot 3s ease-in-out infinite, fadeInRight 1s ease-out;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));
}

/* Added fade transitions for robot */
.robot-fade-enter-active {
  animation: fadeInRight 0.8s ease-out;
}

.robot-fade-leave-active {
  animation: fadeOutRight 0.8s ease-out;
}

/* Robot floating animation */
@keyframes floatingRobot {

  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }

  50% {
    transform: translateY(-20px) rotate(2deg);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  to {
    opacity: 0;
    transform: translateX(50px);
  }
}

@keyframes pages_colorIn__r4Ogf {
  0% {
    filter: grayscale(1);
  }

  100% {
    filter: grayscale(0);
  }
}

/* Added responsive breakpoints */
@media (max-width: 600px) {
  .logo-mobile {
    width: 35%;
    top: 5%;
  }

  .robot-image {
    max-height: 45%;
  }
}

@media (max-width: 400px) {
  .logo-mobile {
    width: 40%;
  }
}
</style>
